<template>
  <div class="tab-container">
    <!-- Cybozu Office モーダル START -->
    <b-modal width="680px" :active.sync="isModalCybozuOffice">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <div class="cover-filter">
            <p class="card-header-title title">
            Cybozu Office 連携
            </p>
          </div>
        </header>
        <div class="card-content parent-box">
          <div class="box-request">
            <p style="text-align: left; padding: 15px;">
              Cybozu Officeとのスケジュール同期を行うことが可能です。<br/>
              ※ WSDLのパス については、システム担当者にお伺いください。
            </p>
            <div style="text-align: left; padding: 15px;">
              WSDLのパス：
              <input class="input" style="width: 358px; height: 24px; color: #222; font-size: 16px;" placeholder="http://localhost:9080/scripts/cbag/ag.exe?WSDL" v-model="user.cybozu_office_wsdl"/>
            </div>
            <div style="text-align: left; padding: 15px;">
              Cybozu Office のログイン名：
              <input class="input" style="width: 250px; height: 24px; color: #222; font-size: 16px;" placeholder="Cybozu Office のログイン名" v-model="user.cybozu_office_id"/>
            </div>
            <div style="text-align: left; padding: 15px;">
              Cybozu Office のパスワード：
              <input class="input" style="width: 250px; height: 24px; color: #222; font-size: 16px;" placeholder="*******" v-model="user.cybozu_office_secret"/>
            </div>
            <div style="text-align: left; padding: 15px;">
              Cybozu Office のユーザーID：
              <input class="input" style="width: 250px; height: 24px; color: #222; font-size: 16px;" placeholder="16" v-model="user.cybozu_office_uid"/>
            </div>
            <div style="text-align: left; padding: 15px;">
              Basic 認証：
              <b-switch size="is-small" v-model="user.cybozu_office_basic">切替</b-switch>
              <span style="margin-left: 17px; margin-right: 5px;">ID</span>
              <input class="input" style="width: 80px; height: 24px; color: #222; font-size: 16px;" placeholder="basic" v-model="user.cybozu_office_basic_id"/>
              <span style="margin-left: 17px; margin-right: 5px;">パスワード</span>
              <input class="input" style="width: 80px; height: 24px; color: #222; font-size: 16px;" placeholder="*******" v-model="user.cybozu_office_basic_pw"/>
            </div>
            <hr>
            <a @click="setProfile({
                          'cybozu_office_wsdl': user.cybozu_office_wsdl
                        },
                        'company');
                        setProfile({
                          'cybozu_office_id'       : user.cybozu_office_id,
                          'cybozu_office_secret'   : user.cybozu_office_secret,
                          'cybozu_office_uid'      : user.cybozu_office_uid,
                          'cybozu_office_basic'    : user.cybozu_office_basic,
                          'cybozu_office_basic_id' : user.cybozu_office_basic_id,
                          'cybozu_office_basic_pw' : user.cybozu_office_basic_pw,
                        },
                        'profile');reloadCybozuOffice()" class="button is-primary" v-if="!isCybozuAuth">
              保有アカウントと連携する
            </a>
            <a @click="setProfile({
                          'cybozu_office_wsdl': user.cybozu_office_wsdl
                        },
                        'company');
                        setProfile({
                          'cybozu_office_id'       : user.cybozu_office_id,
                          'cybozu_office_secret'   : user.cybozu_office_secret,
                          'cybozu_office_uid'      : user.cybozu_office_uid,
                          'cybozu_office_basic'    : user.cybozu_office_basic,
                          'cybozu_office_basic_id' : user.cybozu_office_basic_id,
                          'cybozu_office_basic_pw' : user.cybozu_office_basic_pw,
                        },
                        'profile');reloadCybozuOffice()" class="button is-primary" :disabled="!user.cybozu_login_id" v-if="isCybozuAuth">
              設定を保存する
            </a>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- Cybozu Office モーダル END -->
    <!-- Garoon モーダル START -->
    <b-modal width="680px" :active.sync="isModal">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <div class="cover-filter">
            <p class="card-header-title title">
            　Garoon 連携
            </p>
          </div>
        </header>
        <div class="card-content parent-box">
          <div class="box-request">
            <p style="text-align: left; padding: 15px;" v-if="!isGaroonAuth">
              Cybozu Garoonとのスケジュール同期を行うことが可能です。<br/>
              ※ クライアントID / サブドメイン / シークレットID については、<br/>
              <span style="margin-left: 14px;"></span>システム担当者にお伺いください。
            </p>
            <p style="text-align: left; padding: 15px;" v-if="isGaroonAuth">
              Cybozu GaroonのログインIDを再設定することができます。<br/>
            </p>
            <div style="text-align: left; padding: 15px;" v-if="!isGaroonAuth">
              クライアントID：
              <input class="input" style="width: 250px; height: 24px; color: #222; font-size: 16px;" placeholder="ID" v-model="user.cybozu_id"/>
            </div>
            <div style="text-align: left; padding: 15px;" v-if="!isGaroonAuth">
              サブドメイン名：https://
              <input class="input" style="width: 250px; height: 24px; color: #222; font-size: 16px;" placeholder="subdomain" v-model="user.cybozu_subdomain"/>.cybozu.com
            </div>
            <div style="text-align: left; padding: 15px;" v-if="!isGaroonAuth">
              シークレットID：
              <input class="input" style="width: 250px; height: 24px; color: #222; font-size: 16px;" placeholder="secret" v-model="user.cybozu_secret"/>
            </div>
            <div style="text-align: left; padding: 15px;">
              ログインID：
              <input class="input" style="width: 250px; height: 24px; color: #222; font-size: 16px;" placeholder="GaroonのログインID" v-model="user.cybozu_login_id"/>
            </div>
            <hr>
            <a @click="setProfile({
                          'cybozu_id': user.cybozu_id,
                          'cybozu_subdomain': user.cybozu_subdomain,
                          'cybozu_secret': user.cybozu_secret,
                        },
                        'company');
                        setProfile({
                          'cybozu_login_id': user.cybozu_login_id,
                        },
                        'profile');" class="button is-primary" :href="'https://' + user.cybozu_subdomain + '.cybozu.com/oauth2/authorization?client_id=' + user.cybozu_id + '&redirect_uri=' + getURLAPI() + '/api/user/redirect/cybozu/&state=state1&response_type=code&scope=g%3aschedule%3aread%20g:base:read%20g:schedule:write'" :disabled="!user.cybozu_id||!user.cybozu_subdomain||!user.cybozu_secret||!user.cybozu_login_id" v-if="!isGaroonAuth">
              保有アカウントと連携する
            </a>
            <a @click="setProfile({
                        'cybozu_login_id': user.cybozu_login_id,
                        },
                        'profile');" class="button is-primary" :disabled="!user.cybozu_login_id" v-if="isGaroonAuth">
              設定を保存する
            </a>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- Garoon モーダル END -->
    <!-- Google モーダル START -->
    <b-modal width="680px" :active.sync="isModalGoogle">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <div class="cover-filter">
            <p class="card-header-title title">
            Google Calendar 連携
            </p>
          </div>
        </header>
        <div class="card-content parent-box">
          <div class="box-request">
            <p style="text-align: left; padding: 15px;">
              Google Calendarとの連携を解除しますか？<br/>
              解除すると再設定が必要となります。<br/>
            </p>
            <hr>
            <a @click="googleAuthRevoke()" class="button is-primary">
              連携を解除する
            </a>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- Google モーダル END -->
    <!-- MSOffice モーダル START -->
    <b-modal width="680px" :active.sync="isModalMSOffice">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <div class="cover-filter">
            <p class="card-header-title title">
            MS Office 365 Outlook Calendar 連携
            </p>
          </div>
        </header>
        <div class="card-content parent-box">
          <div class="box-request">
            <p style="text-align: left; padding: 15px;">
              MS Office 365 Outlook Calendarとの連携を解除しますか？<br/>
              解除すると再設定が必要となります。<br/>
            </p>
            <hr>
            <a @click="msofficeAuthRevoke()" class="button is-primary">
              連携を解除する
            </a>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- MSOffice モーダル END -->
    <div class="menu">
      <div class="menu-item">
        <div class="selectViewType">
          <b-dropdown>
            <button class="button is-primary is-rounded" slot="trigger">
              <span>{{ this.viewType }}</span>
              <b-icon icon="menu-down"></b-icon>
            </button>
            <b-dropdown-item @click="changeViewDay()">日</b-dropdown-item>
            <b-dropdown-item @click="changeViewWeek()">週</b-dropdown-item>
            <b-dropdown-item @click="changeViewMonth()">月</b-dropdown-item>
          </b-dropdown>
          <div class="button is-rounded">
            <span class="mdi mdi-48px mdi-chevron-left" @click="prevView()"></span>
          </div>
          <div class="button is-rounded">
            <span class="mdi mdi-48px mdi-chevron-right" @click="nextView()"></span>
          </div>
          <strong class="nowTime">{{ this.nowTime }}</strong>
        </div>
        <div style="display: flex;">
          <div class="googleAuth" v-if="!isReadSchedule">
            <a class="button" style="border-radius: 50%; background: rgba(0, 0, 0, 0); padding:0; border: none; height: 48px; width: 48px; margin-right: 16px;" @click="googleAuthRedirect()" v-if="!isGoogleAuth">
              <img style="height: 100%;" src="@/assets/template/gcal.png"/>
            </a>
            <a class="button" style="border-radius: 50%; background: rgba(0, 0, 0, 0); padding:0; border: none; height: 48px; width: 48px; margin-right: 16px;" @click="isModalGoogle=true" v-if="isGoogleAuth">
              <img style="height: 100%;" src="@/assets/template/gcal.png"/>
            </a>
          </div>
          <div class="googleAuth" v-if="!isReadSchedule">
            <a class="button" style="font-size: 24px; border-radius: 50%; background: #3333ee; color: white; height: 48px; width: 48px; margin-right: 16px;" @click="isModal=true">G</a>
          </div>
          <div class="googleAuth" v-if="!isReadSchedule">
            <a class="button" style="font-size: 24px; border-radius: 50%; background: #66c2ff; color: white; height: 48px; width: 48px; margin-right: 16px;" @click="isModalCybozuOffice=true">C</a>
          </div>
          <div class="googleAuth" v-if="!isReadSchedule">
            <a class="button" style="font-size: 24px; border-radius: 50%; background: #3333ee; color: white; height: 48px; width: 48px;" @click="msofficeAuthRedirect()" v-if="!isMSOfficeAuth">M</a>
            <a class="button" style="font-size: 24px; border-radius: 50%; background: #3333ee; color: white; height: 48px; width: 48px;" @click="isModalMSOffice = true"  v-if="isMSOfficeAuth">M</a>
          </div>
        </div>
      </div>
      <div id="calendar" style="position: relative;">
        <div style="display: flex; justify-content: center; align-items: center; height: 100%; width: 100%; position: absolute; z-index: 100000; background: rgba(255, 255, 255, 0.7);" v-if="isReadSchedule">
          <p><span class="mdi mdi-loading mdi-spin mdi-48px"></span></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Calendar from '../../../../node_modules/tui-calendar'
import CreateSchedule from '@/components/ui/CreateSchedule'
import UpdateSchedule from '@/components/ui/UpdateSchedule'
import DeleteSchedule from '@/components/ui/DeleteSchedule'
import moment from 'moment'
import createUUID from '../../../functions/createUUID'

export default {
  name: 'Calendar',
  componentName: 'Calendar',
  components: {
    CreateSchedule,
    UpdateSchedule,
    DeleteSchedule
  },
  data () {
    return {
      selectDate: 'today',
      selected: {},
      calendar: null,
      viewType: '週',
      nowTime: null,
      isModal: false,
      isModalGoogle: false,
      isModalCybozuOffice: false,
      isModalMSOffice: false,
      clientid: null,
      subdomain: null,
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('calendar', ['events', 'isGoogleAuth', 'schedule', 'isReadSchedule', 'isGaroonAuth', 'isCybozuAuth', 'isMSOfficeAuth']),
    computedDate: function () {
      console.debug('*** Start *** computedDate')
      if (this.selectDate === 'today') {
        console.info('today')
        var d = new Date()
        var month = '' + (d.getMonth() + 1)
        var day = '' + d.getDate()
        var year = d.getFullYear()
        if (month.length < 2) month = '0' + month
        if (day.length < 2) day = '0' + day
        console.debug('*** End *** computedDate')
        return [year, month, day].join('/')
      } else {
        console.debug('*** End *** computedDate')
        return [year, month, day].join('/')
        return this.selectDate.split('-').join('/')
      }
    }
  },
  mounted () {
    console.debug('*** Start *** mounted')
    const uriVO = process.env.WS_ENDPOINT + 'vo/user_list/' + this.user.companyID + '/' + this.user.userHash
    this.$store.dispatch('virtualOffice/connectVirtualOfficeSV', uriVO)
    const con = {'is_connect': true}
    this.$store.dispatch('auth/setUserConnect', con)

    if (this.$route.query.msoffice) {
      alert('連携が完了いたしました。同期を行いますので、再読み込みいたします。')
      location.href = '/dashboard/calendar'
    } else if (this.$route.query.error_msoffice) {
      alert('エラーが発生いたしました。\nOffice365のアカウントが正しく認証されているか確認をお願いいたします。')
      location.href = '/dashboard/calendar'
    } else if (this.$route.query.cybozu_garoon) {
      alert('連携が完了いたしました。同期を行いますので、再読み込みいたします。')
      location.href = '/dashboard/calendar'
    } else if (this.$route.query.error) {
      alert('エラーが発生いたしました。\nクライアントID / サブドメイン / シークレットIDが正しいかどうか確認をお願い致します。')
      location.href = '/dashboard/calendar'
    } else {
      var calendarId = this.user.email + '_' + this.user.companyID
      this.startCalendar()
      this.calendar.setCalendars(this.schedule)
      this.calendar.setCalendarColor(calendarId, {
        color: '#000',
        bgColor: '#EEaCCC',
        borderColor: '#EEaCCC'
      })
      this.calendar.clear()
      for (var i in this.schedule) {
        this.calendar.createSchedules([this.schedule[i]])
        this.viewTime()
      }
    }
    console.debug('*** End *** mounted')
  },
  watch: {
    schedule () {
      var calendarId = this.user.email + '_' + this.user.companyID
      this.calendar.setCalendars(this.schedule)
      this.calendar.setCalendarColor(calendarId, {
        color: '#000',
        bgColor: '#EEaCCC',
        borderColor: '#EEaCCC'
      })
      this.calendar.clear()
      for (var i in this.schedule) {
        this.calendar.createSchedules([this.schedule[i]])
        this.viewTime()
      }
    }
  },
  methods: {
    reloadCybozuOffice () {
      alert('連携用の設定を保存いたしました。スケジュールの同期には数分かかります。同期がされない場合は、設定内容が正しいか確認をお願い致します。再読み込みします。')
      location.reload()
    },
    getURLAPI () {
      if (process.env.NODE_ENV === 'development') {
        return 'https://localhost:8000'
      } else if (process.env.NODE_ENV === 'staging') {
        return 'https://w2.ndr-staging.work'
      } else if (process.env.NODE_ENV === 'third') {
        return 'https://robottte.hr-monster.io'
      } else {
        return 'https://hr-monster.io'
      }
    },
    startCalendar () {
      this.calendar = new Calendar('#calendar', {
        defaultView: 'week',
        taskView: false,
        week: {
          daynames: ['日', '月', '火', '水', '木', '金', '土']
        },
        month: {
          daynames: ['日', '月', '火', '水', '木', '金', '土']
        },
        template: {
          monthGridHeader: function (model) {
            var date = new Date(model.date)
            var template = '<span class="tui-full-calendar-weekday-grid-date">' + date.getDate() + '</span>'
            return template
          },
          allday: (schedule) => {
            console.debug('*** Start *** allday')
            console.debug('schedule: ' + schedule)
            var viewType = this.calendar.getViewName()
            if (viewType !== 'month') {
              console.info('not month')
              console.debug('*** End *** allday')
              return '<strong>' + schedule.title + '</strong>'
            } else {
              console.info('month')
              console.debug('*** End *** allday')
              return this.getTimeTemplate(schedule, true)
            }
          },
          alldayTitle: () => {
            return '<span class="tui-full-calendar-left-content"></span>';
          },
          time: (schedule) => {
            console.debug('*** Start *** time')
            console.debug('schedule: ' + schedule)
            var viewType = this.calendar.getViewName()
            if (viewType !== 'month') {
              return '<strong>' + schedule.title + '</strong>'
            } else {
              return this.getTimeTemplate(schedule, false)
            }
            console.debug('*** End *** time')
          }
        },
        useCreationPopup: true,
        useDetailPopup: true,
        calendars: []
      })
      this.calendar.on(
        {
          'beforeCreateSchedule': async (e) => {
            console.debug('*** Start *** beforeCreateSchedule')
            e.calendarId = this.user.email + '_' + this.user.companyID
            console.log('beforeCreateSchedule: ' + JSON.stringify(e))
            const id = createUUID()
            var createdSchedule = {
              id: id,
              calendarId: e.calendarId,
              title: e.title,
              location: e.location,
              start: e.start._date,
              end: e.end._date,
              isAllDay: e.isAllDay,
              category: e.isAllDay ? 'allday' : 'time',
              state: e.state,
              isVisible: true,
              isPrivate: e.raw.class,
              isReadOnly: false,
              color: '#000',
              bgColor: '#EEaCCC',
              borderColor: '#EEaCCC',
              dragBgColor: '#EEaCCC'
            }
            console.log('CHECK CREATE SCHEDULE: ' + JSON.stringify(createdSchedule))
            this.calendar.createSchedules([createdSchedule])
            this.$store.dispatch('calendar/addEvent', {createdSchedule: createdSchedule})
            console.debug('*** End *** beforeCreateSchedule')
          },
          'beforeUpdateSchedule': async (e) => {
            console.debug('*** Start *** beforeUpdateSchedule')
            console.log('SHOW THE EVENT:' + JSON.stringify(e))
            var scheduleId = e.schedule.id
            var calendarId = e.schedule.calendarId
            var updatedSchedule = await {
              id: scheduleId,
              calendarId: calendarId,
              title: e.schedule.title,
              location: e.schedule.location,
              start: e.start._date,
              end: e.end._date,
              isAllDay: e.schedule.isAllDay,
              category: e.schedule.isAllDay ? 'allday' : 'time',
              state: e.schedule.state,
              isVisible: true,
              isPrivate: e.schedule.isPrivate,
              isReadOnly: false
            }
            console.log('CHECK UPDATED SCHEDULE:' + JSON.stringify(updatedSchedule))
            this.calendar.updateSchedule(scheduleId, calendarId, updatedSchedule)
            await this.$store.dispatch('calendar/updateSchedule', {updatedSchedule: updatedSchedule})
            console.debug('*** End *** beforeUpdateSchedule')
          },
          'beforeDeleteSchedule': (e) => {
            console.debug('*** Start *** beforeDeleteSchedule')
            console.log('beforeDeleteSchedule' + JSON.stringify(e))
            var scheduleId = e.schedule.id
            var calendarId = e.schedule.calendarId
            var deletedSchedule = {
              id: scheduleId,
              calendarId: calendarId,
              title: e.schedule.title,
              location: e.schedule.location,
              start: e.schedule.start._date,
              end: e.schedule.end._date,
              isAllDay: e.schedule.isAllDay,
              category: e.schedule.category,
              state: e.schedule.state,
              isVisible: false,
              isPrivate: e.schedule.isPrivate,
              isReadOnly: false
            }
            console.log('CHECK DELETED SCHEDULE' + JSON.stringify(deletedSchedule))
            this.calendar.deleteSchedule(scheduleId, calendarId)
            this.$store.dispatch('calendar/deleteSchedule', {deletedSchedule: deletedSchedule})
            console.debug('*** End *** beforeDeleteSchedule')
          },
          'clickSchedule': (e) => {
            console.debug('*** Start *** clickSchedule')
            console.log('CHECK SCHEDULE', e.schedule)
            console.debug('*** End *** clickSchedule')
          }
        }
      )
      this.setSchedule()
      this.viewTime()
    },
    setProfile (data, type) {
      console.debug('*** Start *** setProfile')
      console.debug('data: ' + JSON.stringify(data))
      console.debug('type: ' + JSON.stringify(type))
      this.$store.dispatch('auth/setProfile', {data: data, type: type})
        .then(() => { if (this.error) { this.errorBar(this.error) } })
        .then(() => { if (!this.error) { this.successBar() } })
      console.debug('*** End *** setProfile')
    },
    errorBar (e) {
      console.debug('*** Start *** errorBar')
      console.error('e: ' + JSON.stringify(e))
      this.$buefy.snackbar.open({
        message: '正常に保存が完了しませんでした。再読み込みしてください。',
        type: 'is-danger',
        position: 'is-top'
      })
      console.debug('*** End *** errorBar')
    },
    successBar () {
      console.debug('*** Start *** successBar')
      this.$buefy.snackbar.open({
        message: 'セーブしました！',
        type: 'is-success',
        position: 'is-top'
      })
      console.debug('*** End *** successBar')
    },
    googleAuthRedirect () {
      console.debug('*** Start *** googleAuthRedirect')
      this.$store.dispatch('calendar/googleAuthRedirect', {email: this.user.email, username: this.user.username})
      console.debug('*** End *** googleAuthRedirect')
    },
    msofficeAuthRedirect () {
      const clientId = 'ace30ca4-3e64-47dc-8217-cbc5f8ce9611'
      const redirectURI = process.env.LOC_HOST + '/api/user/redirect/msoffice/'
      const scope = 'https://graph.microsoft.com/Calendars.Read https://graph.microsoft.com/Calendars.ReadWrite https://graph.microsoft.com/User.Read.All offline_access'
      location.href = 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize?response_type=code&client_id=' + clientId + '&scope=' + scope + '&redirect_uri=' + redirectURI
    },
    changeViewDay () {
      console.debug('*** Start *** changeViewDay')
      this.calendar.changeView('day', true)
      this.viewType = '日'
      this.viewTime()
      console.debug('*** End *** changeViewDay')
    },
    changeViewWeek () {
      console.debug('*** Start *** changeViewWeek')
      this.calendar.changeView('week', true)
      this.viewType = '週'
      this.viewTime()
      console.debug('*** End *** changeViewWeek')
    },
    changeViewMonth () {
      console.debug('*** Start *** changeViewMonth')
      this.calendar.changeView('month', true)
      this.viewType = '月'
      this.viewTime()
      console.debug('*** End *** changeViewMonth')
    },
    nextView () {
      console.debug('*** Start *** nextView')
      this.calendar.next()
      this.viewTime()
      console.debug('*** End *** nextView')
    },
    prevView () {
      console.debug('*** Start *** prevView')
      this.calendar.prev()
      this.viewTime()
      console.debug('*** End *** prevView')
    },
    changeToday () {
      console.debug('*** Start *** changeToday')
      this.calendar.today()
      this.viewTime()
      console.debug('*** End *** changeToday')
    },
    viewTime () {
      console.debug('*** Start *** viewTime')
      var viewName = this.calendar.getViewName()
      var options = this.calendar.getOptions()
      if (viewName === 'day') {
        console.info('Day')
        this.nowTime = moment(this.calendar.getDate().getTime()).format('YYYY.MM.DD')
      } else if (viewName === 'month' &&
        (!options.month.visibleWeeksCount || options.month.visibleWeeksCount > 4)) {
        console.info('Month')
        this.nowTime = moment(this.calendar.getDate().getTime()).format('YYYY.MM')
      } else {
        console.info('else')
        this.nowTime = moment(this.calendar.getDateRangeStart().getTime()).format('YYYY.MM.DD') + ' ~ ' + moment(this.calendar.getDateRangeEnd().getTime()).format(' MM.DD')
      }
      console.debug('*** End *** viewTime')
    },
    getTimeTemplate (schedule, isAllDay) {
      console.debug('*** Start *** getTimeTemplate')
      console.debug('schedule: ' + JSON.stringify(schedule))
      console.debug('isAllDay: ' + JSON.stringify(isAllDay))
      var start = moment(schedule.start.toUTCString())
      if (!isAllDay) {
        console.info('isAllDay is false')
        return '<strong>' + schedule.title + '  ' + start.format('HH:mm') + '~' + '</strong>'
      } else {
        console.info('isAllDay is true')
        return '<strong>' + schedule.title + '</strong>'
      }
      console.debug('*** End *** getTimeTemplate')
    },
    setSchedule () {
      console.debug('*** Start *** setSchedule')
      // var calendarId = this.user.email + '_' + this.user.companyID
      console.debug('*** End *** setSchedule')
    },
    googleAuthRevoke () {
      console.debug('*** Start *** googleAuthRevoke')
      this.$store.dispatch('auth/googleAuthRevoke')
      this.$store.dispatch('calendar/changeGoogleAuth')
      console.debug('*** End *** googleAuthRevoke')
    },
    msofficeAuthRevoke () {
      this.$store.dispatch('auth/msofficeAuthRevoke')
      this.$store.dispatch('calendar/changeMSOfficeAuth')
    }
  }
}
</script>

<style scoped>
input {
  border: none;
  color: transparent;
  font-size: 0%;
}

.calendar-body {
  height: 70vh;
}

.event-box {
  height: 70vh;
  border-left: solid 2px whitesmoke;
}

.tab-container {
  display: flex;
  flex-direction: row;
  margin: 0;
  height: 100vh;
  width: calc(100% - 200px);
  padding: 20px;
  background: #FEFEFE;
}

.menu {
  text-align: left;
  height: calc(100vh - 80px);
  width: 100%;
}

.menu-item {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: flex-end;
  height: 75px;
}

.googleAuth {
  padding-bottom: 20px;
}

.selectViewType {
  padding-bottom: 20px;
}

.preview {
  padding-bottom: 20px;
}

.nextview {
  padding-bottom: 20px;
}

.today {
  font-size: 1.5em;
  padding-left: 20px;
  padding-top: 10px;
  text-align: end;
  padding-bottom: 20px;
}

.nowTime {
  font-size: 1.5em;
  padding-left: 20px;
  padding-top: 10px;
  padding-bottom: 15px;
}

.googleAuthCancel {
  padding-left: 20px;
  padding-bottom: 20px;
}

#calendar {
  width: 100%;
  height: calc(100% - 125px);
  box-sizing: border-box;
  border: solid thin #f0f0f0;
}

.createForm {
  margin: 0px 10px;
}

.circle_btn {
  border: none;
  display: inline-block;
  padding: 0.5em 1em;
  border-radius: 50%;
  background: #208ceb;
  color: white;
  font-size: 18px;
  font-weight: 700;
}

.square_btn {
  display: inline-block;
  padding: 0.5em 1em;
  text-decoration: none;
  border-radius: 3px;
  font-weight: bold;
  color: #FFF;
  background-image: -webkit-linear-gradient(45deg, #208ceb 0%, #709dff 100%);
  background-image: linear-gradient(45deg, #208ceb 0%, #709dff 100%);
  transition: .4s;
}

.square_btn:hover {
  background-image: -webkit-linear-gradient(45deg, #208ceb 50%, #709dff 100%);
  background-image: linear-gradient(45deg, #208ceb 50%, #709dff 100%);
}

.calendar-bar {
  width: 16px;
  height: 16px;
  margin-right: 5px;
  display: inline-block;
  border: 1px solid #eee;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/Calendar/Calendar.vue